// The image and video lightbox (js/lightbox.js) on demand: GLightbox, Plyr and their styles are a chunk of their own,
// loaded only on pages with lightbox links (pages without them never download it). A click that comes before the chunk
// has arrived waits for it and then opens the clicked image in its gallery. The two-click player (initVideoConsent.js)
// shares the same chunk through loadLightbox().
const SELECTOR = 'a[data-lightbox], a[data-fancybox]';

let chunk = null;

export function loadLightbox() {
    chunk ??= import(/* webpackChunkName: "lightbox" */ '../lightbox');

    return chunk;
}

export default function initLightbox() {
    if (!document.querySelector(SELECTOR)) {
        return;
    }

    let lightbox = null;
    const ready = loadLightbox().then(({default: createLightbox}) => {
        lightbox = createLightbox();

        return lightbox;
    });

    // until GLightbox has bound its own handlers to the links
    document.addEventListener('click', (event) => {
        const link = lightbox ? null : event.target.closest(SELECTOR);
        if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey) {
            return;
        }
        event.preventDefault();
        ready.then((instance) => instance.open(link));
    });
}
